module.exports = __webpack_public_path__ + "img/certificates.853afbac.svg";